//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import { checkBreakpoint, devices } from '~/helpers';

export default {
    name: 'BowFiltersToggle',

    props: {
        white: {
            default: true,
            type: Boolean,
        },
    },

    data: () => ({
        checkBreakpointDownXl: false,
    }),

    computed: {
        ...mapState({
            activeFilters: ({ filters }) => filters.activeFilters,
            isFiltersOpen: ({ ui }) => ui.isFiltersOpen,
        }),

        ...mapGetters(['filters/GET_ACTIVE_FILTERS', 'ui/GET_IS_FILTERS_OPEN']),

        state() {
            if (this.isFiltersOpen === true) {
                return 'open';
            }

            return 'close';
        },
    },

    mounted() {
        this.checkBreakpointDownXl = checkBreakpoint.down('xl');
    },

    methods: {
        ...mapActions(['ui/UPDATE_IS_FILTERS_OPEN']),

        handleToggle() {
            this.$store.dispatch(
                'ui/UPDATE_IS_FILTERS_OPEN',
                !this.isFiltersOpen
            );

            document.querySelector('.o-header__wrapper').style.transform =
                'translateY(0)';

            if (devices.isDesktop === false) {
                document
                    .querySelector('body')
                    .classList.toggle('overflow-y-hidden');

                return;
            }

            document
                .querySelector('body')
                .classList.remove('overflow-y-hidden');
        },
    },
};
